const invoice = (q) => {
  return `
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX gbi: <http://pms.coentunnelcompany.nl/instance#>
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX gb: <http://pms.coentunnelcompany.nl/rdl#>

    SELECT DISTINCT
      ?naam
      ?netto
      ?datum
      ?beschikbaarheidsCorrectie
      ?prestatieKorting
      ?bruto
      ?fileId
    WHERE
    {
      ?m    ?instance     rdf:type           gb:AvailabilityCalculation .
      ?instance     gb:hasName                   ?naam .
      ?instance     gb:hasOutput                 ?netto .
      OPTIONAL { ?instance     gb:bbv            ?bruto . }
      OPTIONAL { ?instance     gb:pk             ?prestatieKorting . }
      OPTIONAL { ?instance     gb:bc             ?beschikbaarheidsCorrectie . }
      OPTIONAL { ?instance     gb:fileId         ?fileId . }

      BIND(createdAt(?m) as ?datum)

      ?instance     gb:quarter <${q}>
    }
  `
}

const inspectie = (q) => {
  return `
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX gb: <http://pms.coentunnelcompany.nl/rdl#>
    PREFIX gbi: <http://pms.coentunnelcompany.nl/instance#>

    SELECT DISTINCT
      ?name
      ?verificationMoment
      ?gemetenWaarde
      ?code
      ?status
    WHERE
    {
      ?instance                     rdf:type                gb:Inspectie          .
      ?instance                     gb:hasName              ?name                 .
      ?instance                     gb:hasProperty          ?momentId             .
      ?momentId                     rdf:type                gb:VerificationMoment .
      ?momentId                     gb:hasValue             ?verificationMoment   .

      ?instance                     gb:hasAsResult          ?physicalPerformanceMeasure .
      ?physicalPerformanceMeasure   rdf:type                gb:PhysicalPerformanceMeasure .

      OPTIONAL { ?physicalPerformanceMeasure   gb:hasValue             ?gemetenWaarde }

      ?instance                     gb:type                 ?codeId .
      ?codeId                       gb:isIdentifiedBy       ?code .

      ?instance                     gb:hasAsResult          ?statusId .
      ?statusId                     rdf:type                gb:PhysicalConditionStatus .
      ?statusId                     gb:isIdentifiedByRule   ?status .

      <${q}>                        gb:startDate            ?qstart .
      <${q}>                        gb:endDate              ?qend   .

      FILTER(?verificationMoment >= ?qstart)
      FILTER(?verificationMoment <= ?qend)
    }
  `
}

const historicInterventies = (q) => {
  return`
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX gbi: <http://pms.coentunnelcompany.nl/instance#>
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX gb: <http://pms.coentunnelcompany.nl/rdl#>

    SELECT DISTINCT
      ?date
      ?documentID
      ?reason
      ?subject
      ?oldValue
      ?newValue
    WHERE
    {
      ?m ?instance rdf:type gb:Intervention .

      ?instance   gb:appliesTo    ?record .

      OPTIONAL { ?instance gb:isJustifiedBy            ?reason        }
      OPTIONAL { ?instance gb:isRepresentedIn          ?documentID    }
      OPTIONAL { ?record   gb:oldObject                ?oldValue      }

      ?record       gb:newSubject   ?subject .
      ?record       gb:newObject    ?newValue .

      BIND(createdAt(?m) as ?date)

      <${q}>        gb:startDate                 ?qstart .
      <${q}>        gb:endDate                   ?qend   .

      FILTER(createdAt(?m) < ?qend)
      FILTER(createdAt(?m) > ?qstart)
    }
  `
}

const interventies = (q) => {
  return`
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX gbi: <http://pms.coentunnelcompany.nl/instance#>
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX gb: <http://pms.coentunnelcompany.nl/rdl#>

    SELECT DISTINCT
      ?instance
      ?date
      ?documentID
      ?reason
    WHERE
    {
      ?m ?instance rdf:type gb:Intervention .

      ?instance   gb:quarter    <${q}> .

      OPTIONAL { ?instance gb:isJustifiedBy            ?reason        }
      OPTIONAL { ?instance gb:isRepresentedIn          ?documentID    }

      BIND(createdAt(?m) as ?date)
    }
  `
}

const onderhoudsnacht = (q) => {
  return`
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX gb: <http://pms.coentunnelcompany.nl/rdl#>
    PREFIX gbi: <http://pms.coentunnelcompany.nl/instance#>

    SELECT DISTINCT
      ?name
      ?beginOfLife
      ?endOfLife
    WHERE
    {
      ?instance   rdf:type             gb:Onderhoudsnacht .
      ?instance   gb:hasName           ?name .

      {
        ?instance   gb:hasBeginOfLife    ?beginOfLife .
        ?instance   gb:hasEndOfLife      ?endOfLife   .
        <${q}>  gb:startDate       ?qstart      .
        <${q}>  gb:endDate         ?qend        .

        FILTER(!(?beginOfLife > ?qend ))
        FILTER(!(?endOfLife < ?qstart ))

      } UNION {
        ?instance   gb:hasBeginOfLife    ?bol .
        <${q}>  gb:startDate        ?qstart .
        <${q}>  gb:endDate          ?qend   .

        MINUS{ ?instance gb:hasEndOfLife ?endOfLife . }
        FILTER(!(?bol > ?qend ))
      }
    }
  `
}

const onderhoudsweekend = (q) => {
  return`
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX gb: <http://pms.coentunnelcompany.nl/rdl#>
    PREFIX gbi: <http://pms.coentunnelcompany.nl/instance#>

    SELECT DISTINCT
      ?name
      ?beginOfLife
      ?endOfLife
    WHERE
    {
      ?instance  rdf:type             gb:Onderhoudsweekend .
      ?instance  gb:hasName           ?name .

      {
        ?instance   gb:hasBeginOfLife    ?beginOfLife .
        ?instance   gb:hasEndOfLife      ?endOfLife   .
        <${q}>  gb:startDate       ?qstart      .
        <${q}>  gb:endDate         ?qend        .

        FILTER(!(?beginOfLife > ?qend ))
        FILTER(!(?endOfLife < ?qstart ))

      } UNION {
        ?instance   gb:hasBeginOfLife    ?bol .
        <${q}>  gb:startDate        ?qstart .
        <${q}>  gb:endDate          ?qend   .

        MINUS{ ?instance gb:hasEndOfLife ?endOfLife . }
        FILTER(!(?bol > ?qend ))
      }
    }
  `
}

const physicalLaneClosure = (q) => {
  return`
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX gb: <http://pms.coentunnelcompany.nl/rdl#>
    PREFIX gbi: <http://pms.coentunnelcompany.nl/instance#>

    SELECT DISTINCT
      (min(?_name) as ?name)
      (min(?_code) as ?code)
      (group_concat(?full_name) as ?wegvakken)
    WHERE
    {

      ?instance  rdf:type          gb:PhysicalLaneClosure .
      ?instance  gb:hasName        ?_name                 .
      ?instance  gb:isIdentifiedBy ?_code                 .

      ?instance  gb:isExecutedOn   ?wv                    .
      ?wv    gb:hasName            ?wv_name               .
      ?trace gb:consistsOf         ?wv                    .
      ?trace gb:hasName            ?trace_name            .
      BIND(concat(?trace_name, ",", ?wv_name) as ?full_name)

      {
        ?instance   gb:hasBeginOfLife    ?beginOfLife .
        ?instance   gb:hasEndOfLife      ?endOfLife   .
        <${q}>      gb:startDate         ?qstart      .
        <${q}>      gb:endDate           ?qend        .

        FILTER(!(?beginOfLife > ?qend ))
        FILTER(!(?endOfLife < ?qstart ))

      } UNION {
        ?instance   gb:hasBeginOfLife   ?beginOfLife .
        <${q}>      gb:startDate        ?qstart      .
        <${q}>      gb:endDate          ?qend        .

        MINUS{ ?instance gb:hasEndOfLife ?endOfLife . }
        FILTER(!(?beginOfLife > ?qend ))
      }

    } GROUP BY ?instance
  `
}

const reeleAfsluitingen = () => {
  return`
    PREFIX gb: <http://pms.coentunnelcompany.nl/rdl#>

    SELECT DISTINCT
      ?nummer
      ?relatics
      ?start
      ?eind
      ?aanleiding
    WHERE
    {
      <reeleEffectieveAfsluitingen> <hasItem>       ?item       .
      ?item                         <nummer>        ?nummer     .
      ?item                         <relaticsLink>  ?relatics   .
      ?item                         <start>          ?start      .
      ?item                         <eind>          ?eind       .
      OPTIONAL {
        ?item                       <hasMaatregel>  ?maatregel  .
        ?maatregel                  <aanleiding>    ?aanleiding .
      }
    }
  `
}

const virtueleAfsluitingen = () => {
  return`
    PREFIX gb: <http://pms.coentunnelcompany.nl/rdl#>

    SELECT DISTINCT
      ?now
      ?start
      ?eind
      ?duur
      ?code
      ?melding
      ?fullCode
      ?status
    WHERE {
      {
        ?result                         <now>           ?now        .
        ?result                           <hasVirtueleKomendeAfsluitingen>  <virtueleKomendeAfsluitingen> .
        <virtueleKomendeAfsluitingen>    <hasItem>       ?item       .
        BIND('coming' as ?status)

        ?item                              <start>          ?start      .
        OPTIONAL { ?item                  <eind>          ?eind       . }
        ?item                              <duur>          ?duur       .

        ?item                              <hasRegel>      ?regel      .
        ?regel                            <code>          ?code       .

        ?item                              <hasMeldingen>  ?meldingen  .
        ?meldingen                        <melding>        ?melding    .

        ?item                              <hasRijstroken> ?rijstroken .
        ?rijstroken                        <fullCode>      ?fullCode   .

      } UNION {
        ?result                         <now>           ?now        .
        ?result                           <hasVirtueleEffectieveAfsluitingen>  <virtueleEffectieveAfsluitingen> .

        <virtueleEffectieveAfsluitingen>  <hasItem>       ?item       .
        BIND('active' as ?status)

        ?item                              <start>          ?start      .
        OPTIONAL { ?item                  <eind>          ?eind       . }
        ?item                              <duur>          ?duur       .

        ?item                              <hasRegel>      ?regel      .
        ?regel                            <code>          ?code       .

        ?item                              <hasMeldingen>  ?meldingen  .
        ?meldingen                        <melding>        ?melding    .

        ?item                              <hasRijstroken> ?rijstroken .
        ?rijstroken                        <fullCode>      ?fullCode   .
      }
    }`
}

const ttrQuery = () => {
  return`
    PREFIX xsd:  <http://www.w3.org/2001/XMLSchema#>
    PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX gb:   <http://pms.coentunnelcompany.nl/rdl#>
    PREFIX gbi:  <http://pms.coentunnelcompany.nl/instance#>

    SELECT DISTINCT ?bk ?ttr
    WHERE
    {
      ?rule    rdf:type          gb:AvailabilityRule .
      ?rule    gb:isIdentifiedBy ?bk  .
      ?rule    gb:hasProperty    ?p   .
      ?p       rdf:type          gb:TTR .
      ?p       gb:hasValue       ?ttr
    }
  `
}

const nokSignalen = () => {
  return`
  PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
  PREFIX gb: <http://pms.coentunnelcompany.nl/rdl#>
  PREFIX gbi: <http://pms.coentunnelcompany.nl/instance#>
  SELECT ?signalCode ?signalNaam ?beginOfLife ?statusName ?bk ?ttr ?trace ?location
  WHERE {

    {
      SELECT ?signal ?status ?statusName ?beginOfLife WHERE {

        {{SELECT ?status WHERE {
          ?status gb:beforeRuleEvaluation gbi:StatusNok
        }}} UNION {
          VALUES ?status { gbi:StatusNok gbi:Undefined }
        }
        ?status gb:hasName ?statusName .

        ?rel   ?signal gb:hasStatus ?status  .
        ?rel   gb:hasBeginOfLife    ?beginOfLife .
        MINUS { ?rel gb:hasEndOfLife ?endOfLife . }
      }
    }

    OPTIONAL { 
      ?rule gb:references ?signal . 
      ?rule gb:isIdentifiedBy ?bk . 
      ?rule gb:hasProperty ?p . 
      ?p rdf:type gb:TTR . 
      ?p gb:hasValue ?ttr 
    }
    OPTIONAL {
      ?fpo gb:hasOutput ?signal .
      ?fpo gb:isLocatedAt ?l .
      ?l gb:hasName ?location .
      ?t gb:consistsOf ?l .
      ?t gb:hasName ?trace .
    }

    ?signal gb:isIdentifiedByRule   ?signalCode               .
    OPTIONAL {
      ?signal gb:isIdentifiedByOPC    ?signalNaam               .
    }
      
  } ORDER BY ?signalNaam ?bk ?trace ?location
  `
}

export {
  invoice,
  inspectie,
  historicInterventies,
  interventies,
  ttrQuery,
  nokSignalen,
  onderhoudsnacht,
  onderhoudsweekend,
  physicalLaneClosure,
  reeleAfsluitingen,
  virtueleAfsluitingen
}
